import { Reducer } from 'redux';
import { ResetStore } from 'types/App';
import {
  CompanyGetExperience,
  IExperienceCompanyState,
  initialExperienceCompanyState,
  TCompanyGetExperienceAction,
} from 'experience/types/ExperienceCompany';

export const experienceCompanyReducer: Reducer<
  IExperienceCompanyState,
  TCompanyGetExperienceAction
> = (state = initialExperienceCompanyState, action) => {
  switch (action.type) {
    case ResetStore.RESET: {
      return initialExperienceCompanyState;
    }

    case CompanyGetExperience.REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case CompanyGetExperience.SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
      };

    case CompanyGetExperience.FAILED: {
      return {
        ...state,
        isLoading: false,
      };
    }

    default:
      return state;
  }
};
